import { Observer } from 'mobx-react-lite';
import React, { useRef } from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import BaseIcon from '../BaseIcon/BaseIcon';
// import './BaseSelectorSystemInner.scss';
export function BaseSelectorSystemInner(props) {
    var p = useProps(props);
    var ref = useRef(null);
    var s = useStore(function () { return ({
        get value() {
            if (p.valueFieldRef instanceof Array) {
                return p.valueFieldRef.map(function (s) { return s + ''; });
            }
            else {
                return p.valueFieldRef;
            }
        }
    }); });
    var renderOptions = function () {
        return p.options.map(function (o, i) {
            var value = p.valueGetter(o);
            var label = p.optionLabelRenderer(o);
            var disabled = p.disabledOptionChecker(o);
            return (React.createElement("option", { key: value + '' + i, value: value, disabled: disabled }, label));
        });
    };
    var handleOnChange = function (e) {
        var _a;
        var value = e.currentTarget.value;
        p.onChange && p.onChange(value);
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    var handleOnBlur = function (e) {
        var value = e.currentTarget.value;
        p.onBlur && p.onBlur(value);
    };
    var handleClick = function (e) {
        var _a;
        (_a = p.onClick) === null || _a === void 0 ? void 0 : _a.call(p, e);
    };
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "BaseSelectorInner", onClick: handleClick },
            React.createElement("select", { className: "BaseSelectorSelect", value: s.value, name: p.name, onChange: handleOnChange, onBlur: handleOnBlur, disabled: p.disabled, required: p.required, multiple: p.multiple, ref: ref },
                React.createElement("option", { value: p.emptyValue }, p.placeholder || 'Please Select'),
                renderOptions()),
            React.createElement(BaseIcon, { name: "dropdown-arrow", size: "1.4rem", variant: "filled" }))); } });
}
export default BaseSelectorSystemInner;
